import React from 'react'
import { connect } from 'react-redux'
import { Button } from '@material-ui/core'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import pick from './utilities/pick'
import deviceDetect from './utilities/deviceDetect'
import getStartLocationForUser from './utilities/getStartLocationForUser'
import mapDispatchers from './utilities/mapDispatchers'
import styles from './CompleteFacebookRedirectLogin.icss'
import EmailInputAndValidation from './components/EmailInputAndValidation'
import EmailRedirectUrlInputAndValidation from './components/EmailRedirectUrlInputAndValidation'

const EMAIL_FOR_LOGIN = 'emailForLogin'
const handleUrlSubmit = (url) => {
	global.location.href = url
}

class CompleteFacebookRedirectLogin extends React.Component {
	constructor(props) {
		super(props)

		this.state = { email: global.localStorage.getItem(EMAIL_FOR_LOGIN) || '' }

		this.handleLogin = this.handleLogin.bind(this)
		//	On iOS using instagram or pwa, we need to paste the url in when using email.
		this.needsUrlPasted = deviceDetect.isIos() && (deviceDetect.isInstagram() || deviceDetect.isPwa())
	}

	static getDerivedStateFromProps(props) {
		return props.facebookLoginCompleteErrorEmailAccountExists ?
			{ email: props.facebookLoginCompleteErrorEmailAccountExists } :
			null
	}

	componentDidMount() {
		this.props.appBackButtonFunction(() => this.props.appRedirect('/login'))
		this.props.authFacebookRedirectLoginComplete()
	}

	componentDidUpdate() {
		//  See if the user actually got logged in.
		if (this.props.facebookLoginCompleteSuccess &&
			!this.props.user.isAnonymous && !this.props.user.isLoading) {
			this.props.appRedirect(getStartLocationForUser(this.props.user))
		}
	}

	handleLogin(email) {
		this.props.authEmailLogin({ email })
		this.setState({ email })
	}

	render() {
		return (
			<section className={styles.surround}>
				<div className={classNames(styles.container, { [styles.fullPageHeight]: this.props.facebookLoginCompleteFail || this.props.authEmailLoginSuccess })}>
					{!this.props.authEmailLoginSuccess && (
						<>
							<h2>{this.context.translate('Completing Facebook login')}</h2>
							{this.props.facebookLoginCompleteFail && (
							<>
								<p>{this.props.facebookLoginCompleteError || this.context.translate('Facebook login failed.')} {this.props.facebookLoginCompleteErrorEmailAccountExists && this.context.translate('Please login with your email here:')}</p>

								{!this.props.facebookLoginCompleteErrorEmailAccountExists && (
									<Button
										fullWidth
										variant="contained"
										onClick={() => this.props.appRedirect('/login')}
										classes={{ root: styles.button, label: styles.label }}
									>
										{this.context.translate('Please login again')}
									</Button>
								)}

								{this.props.facebookLoginCompleteErrorEmailAccountExists && (
								<>
									<EmailInputAndValidation
										fullWidth
										emailHandler={this.handleLogin}
										label={this.context.translate('E-mail address')}
										buttonText={this.context.translate('Login Again')}
										email={this.state.email}
									/>
									{this.props.authEmailLoginFail && (
										<div>
											<span className={styles.validationError}>{this.props.authEmailLoginError ? this.props.authEmailLoginError : this.context.translate('Please enter a valid email')}</span>
										</div>
									)}
								</>
								)}
							</>
							)}
						</>
					)}

					{this.props.authEmailLoginSuccess && (
						<>
							<h2>{this.context.translate('Check Your Email')}</h2>

							{this.needsUrlPasted && (
								<>
									<p>
										{this.context.translate(`We've sent a login link to your email (${this.state.email}), once it arrives copy it and paste it in below.`)}
									</p>
									<EmailRedirectUrlInputAndValidation
										fullWidth
										urlHandler={handleUrlSubmit}
										label={this.context.translate('Login Url')}
										buttonText={this.context.translate('Submit')}
									/>
								</>
							)}
							{!this.needsUrlPasted && (
								<>
									<p>
										{this.context.translate(`We've sent a login link to your email (${this.state.email}). Click it and you’ll be signed in.`)}
									</p>
									<p>
										{this.context.translate('NB: We’ll try to keep you logged in but if you come back and need to log in again just repeat this process. Easy peasy!')}
									</p>
								</>
							)}
						</>
					)}
				</div>
			</section>
		)
	}
}

CompleteFacebookRedirectLogin.propTypes = {
	facebookLoginCompleteSuccess: PropTypes.bool,
	facebookLoginCompleteFail: PropTypes.bool,
	facebookLoginCompleteError: PropTypes.string,
	facebookLoginCompleteErrorEmailAccountExists: PropTypes.string,
	appRedirect: PropTypes.func.isRequired,
	appBackButtonFunction: PropTypes.func.isRequired,
	authFacebookRedirectLoginComplete: PropTypes.func.isRequired,
	authEmailLogin: PropTypes.func.isRequired,
	authEmailLoginError: PropTypes.string,
	authEmailLoginFail: PropTypes.bool,
	authEmailLoginSuccess: PropTypes.bool,
	user: PropTypes.object.isRequired // eslint-disable-line react/forbid-prop-types
}

CompleteFacebookRedirectLogin.contextTypes = {
	translate: PropTypes.func
}

CompleteFacebookRedirectLogin.defaultProps = {
	facebookLoginCompleteSuccess: false,
	facebookLoginCompleteFail: false,
	facebookLoginCompleteError: undefined,
	facebookLoginCompleteErrorEmailAccountExists: undefined,
	authEmailLoginError: undefined,
	authEmailLoginFail: false,
	authEmailLoginSuccess: false
}

export const testing = {
	CompleteFacebookRedirectLogin
}

export default connect(
	/* istanbul ignore next line */
	state => pick(state, ['user', 'facebookLoginCompleteSuccess', 'facebookLoginCompleteFail', 'facebookLoginCompleteError', 'facebookLoginCompleteErrorEmailAccountExists', 'authEmailLoginError', 'authEmailLoginFail', 'authEmailLoginSuccess']),
	/* istanbul ignore next line */
	dispatch => mapDispatchers(dispatch, ['appRedirect', 'appBackButtonFunction', 'authFacebookRedirectLoginComplete', 'authEmailLogin'])
)(CompleteFacebookRedirectLogin)



// WEBPACK FOOTER //
// ./src/CompleteFacebookRedirectLogin.jsx